import { Tag, TagLabel } from '@chakra-ui/react';

export const TradeSideTag = ({ side }: { side?: string }) => {
    if (!side) {
        return null;
    }

    return (
        <Tag size="sm" variant="subtle" colorScheme={side.toUpperCase() === 'BUY' ? 'green' : 'red'}>
            <TagLabel>{side.toUpperCase()}</TagLabel>
        </Tag>
    );
};
